import * as React from 'react'

import { Form, Input } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import { FormInstance, Rule } from 'antd/lib/form'
import { ColProps } from 'antd/lib/col'
import { FormLayout } from 'antd/lib/form/Form'
import { Customer } from '../../types'

type ExtraRules = Partial<{ [k in keyof Customer]: Rule[] }>

type Props = {
  form?: FormInstance
  initialValue?: Customer
  onChange?: (_: Customer) => void
  labelCol?: ColProps
  wrapperCol?: ColProps
  layout?: FormLayout
  extraRules?: ExtraRules
  onFinish?: (_: Customer) => void
}

const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/

const PayerForm = ({
  form,
  initialValue,
  onChange,
  onFinish,
  extraRules,
  labelCol,
  wrapperCol,
}: Props) => {
  const intl = useIntl()

  return (
    <Form<Customer>
      form={form}
      onValuesChange={!!onChange ? (_, v) => onChange(v) : () => {}}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      onFinish={!!onFinish ? onFinish : () => {}}
      initialValues={initialValue}
    >
      <Form.Item
        label={<FormattedMessage id="name" />}
        name="name"
        rules={[
          ...(extraRules?.name ?? []),
          {
            required: true,
            message: <FormattedMessage id="required" />,
          },
        ]}
      >
        <Input placeholder={intl.formatMessage({ id: 'customerName' })} />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage id="email" />}
        name="email"
        rules={[
          ...(extraRules?.email ?? []),
          {
            message: <FormattedMessage id="invalidEmail" />,
            type: 'email',
          },
          {
            required: true,
            message: <FormattedMessage id="required" />,
          },
        ]}
      >
        <Input placeholder={intl.formatMessage({ id: 'customerEmail' })} />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage id="phonenumber" />}
        name="phoneNumber"
        rules={[
          ...(extraRules?.phoneNumber ?? []),
          {
            message: <FormattedMessage id="invalidPhonenumber" />,
            validator: (_, v) =>
              phoneRegex.test(v)
                ? Promise.resolve()
                : Promise.reject('invalid'),
          },
          {
            required: true,
            message: <FormattedMessage id="required" />,
          },
        ]}
      >
        <Input
          placeholder={intl.formatMessage({ id: 'customerPhonenumber' })}
        />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage id="address" />}
        name="address"
        rules={extraRules?.address}
      >
        <Input placeholder={intl.formatMessage({ id: 'customerAddress' })} />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage id="taxNumber" />}
        name="taxNumber"
        rules={extraRules?.taxNumber}
      >
        <Input placeholder={intl.formatMessage({ id: 'customerTaxNumber' })} />
      </Form.Item>
    </Form>
  )
}

export default PayerForm
